export default __webpack_public_path__ + "static/media/image-rocket.8768efb3.png";